module.exports = __webpack_public_path__ + "static/media/staff in department.2a66a224.svg";